import { WizardCompanyFormModel } from '../../../../company/components/wizard-company-form/WizardCompanyForm';
import { legalToWizardCompanyFormModel, wizardCompanyFormModelToLegal } from '../../../../company/components/wizard-company-form/mappers';
import {
  Contact, OfferWizardData, WizardContact,
} from '../../../../providers/api/dtos';

export const toAssignmentWizardSellerModel = (initialData: OfferWizardData, wizardIntentContact?: WizardContact) => {
  const contacts: WizardContact[] = initialData.buyerContacts || [wizardIntentContact].filter((item) => item) as WizardContact[];

  const firstLegalContact = contacts?.find((contact) => contact.legal !== undefined)?.legal;

  return legalToWizardCompanyFormModel(firstLegalContact);
};

export async function toOfferWizardData(existingData: OfferWizardData, values: WizardCompanyFormModel, updatedContacts: Contact[], isBuyerLegalPerson: boolean) {
  const hasPersonTypeChanged = !!existingData.isBuyerLegalPersonOnly !== !!isBuyerLegalPerson;

  const newContacts: WizardContact[] = updatedContacts.map((contact) => {
    const existingContact = existingData.buyerContacts?.find(({ id }) => contact.id === id);

    return {
      ...existingContact,
      id: contact.id,
      legal: undefined,
      ...(hasPersonTypeChanged && { antiMoneyLaundering: undefined }),
      overriddenFields: {
        ...existingContact?.overriddenFields,
        name: contact.name,
        phoneNumber: contact.phoneNumber,
        email: contact.email,
        fiscalCode: contact.fiscalCode,
        birthday: contact.birthday,
        birthplace: contact.birthplace,
        residence: contact.residence,
        citizenship: contact.citizenship,
        identityDocument: contact.identityDocument,
      },
      updatedAt: contact.updatedAt,
    };
  });

  if (isBuyerLegalPerson && updatedContacts.length > 0) {
    const legalContact = newContacts[0];

    newContacts[0] = { ...legalContact, legal: wizardCompanyFormModelToLegal(values) };
  }

  return {
    ...existingData,
    isBuyerLegalPersonOnly: isBuyerLegalPerson,
    buyerContacts: newContacts,
    isDigitallySigned: false,
  };
}
